import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[veaFormHost]',
    standalone: false
})
export class PrFormHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
